export const getUserStats = state => state.userStats;
export const getUserNotificationCount = state => getUserStats(state).notificationCount;
